export const Main = ({ scrollToTarget }) => {
    return (
        <div className="Main">
            <div className="Intro-Txt">
                <h2>Michal Kaszkiel</h2>
                <p>
                    {" "}
                    I specialize in crafting exceptional web solutions tailored
                    to meet your unique needs. I won't only meet but exceed your
                    expectations.
                </p>
                <h1>Web Developer</h1>
                <button
                    className="button-50"
                    onClick={() => scrollToTarget("MyWork")}
                >
                    My Work
                </button>
            </div>
            <div className="Social-Media">
                <a
                    href="https://linkedin.com/in/michał-kaszkiel-11mk11"
                    target="blank_"
                >
                    <i className="fa-brands fa-linkedin"></i>
                </a>
                <a href="https://github.com/michalkaszkiel11" target="blank_">
                    <i className="fa-brands fa-github"></i>
                </a>
                <a
                    href="https://www.instagram.com/michal_error/"
                    target="blank_"
                >
                    <i className="fa-brands fa-instagram"></i>
                </a>
            </div>
            <div className="Main-Img-Cont">
                <div className="Main-Img"></div>
            </div>
            <div className="Iamcoder">
                <strong>{`<strong> I am a coder </strong>`}</strong>
            </div>
            <div className="Languages">
                <div className="icon-border">
                    <i className="fa-brands fa-html5"></i>
                </div>
                <div className="icon-border">
                    <i className="fa-brands fa-react"></i>
                </div>
                <div className="icon-border">
                    <i className="fa-brands fa-js"></i>
                </div>
                <div className="icon-border">
                    <i className="fa-brands fa-node"></i>
                </div>
                <div className="icon-border">
                    <i className="fa-brands fa-css3-alt"></i>
                </div>
            </div>
        </div>
    );
};
